<script>
import { onMounted, ref } from 'vue';

export default {
  setup() {
    onMounted(() => {
      const isIOS = ref(/iPad|iPhone|iPod/.test(navigator.userAgent));
      const isAndroid = ref(/Android/.test(navigator.userAgent));
      if (isIOS.value) {
        window.location.href = (process.env.VUE_APP_IPHONE_URL || '');
      } else if (isAndroid.value) {
        window.location.href = (process.env.VUE_APP_ANDROID_URL || '');
      } else {
        window.location.href = process.env.VUE_APP_DOMAIN_URL;
      }
    });
  },
};
</script>
